"use client";

import type { OrganizerMode } from "@/config/markets";
import type { ListCtaLocation } from "@/lib/analytics/events";
import { ListMyClubBottomSheet } from "./ListMyClubBottomSheet";
import { ListMyClubDialog } from "./ListMyClubDialog";
import { ListYourEventBottomSheet } from "./ListYourEventBottomSheet";
import { ListYourEventDialog } from "./ListYourEventDialog";

interface OrganizerCtaPanelProps {
  mode: OrganizerMode;
  container: "dialog" | "sheet";
  location: ListCtaLocation;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function OrganizerCtaPanel({
  mode,
  container,
  location,
  open,
  onOpenChange,
}: OrganizerCtaPanelProps) {
  if (mode === "form") {
    const Form =
      container === "dialog" ? ListMyClubDialog : ListMyClubBottomSheet;
    return <Form open={open} onOpenChange={onOpenChange} />;
  }

  const Guide =
    container === "dialog" ? ListYourEventDialog : ListYourEventBottomSheet;
  return <Guide open={open} onOpenChange={onOpenChange} location={location} />;
}
